export const SUPPORTED_CURRENCIES = [
  { code: "EUR", symbol: "€", label: "Euro (€)" },
  { code: "AED", symbol: "د.إ", label: "Dirham (AED)" },
  { code: "USD", symbol: "$", label: "Dollar US ($)" },
] as const;

export type CurrencyCode = "EUR" | "AED" | "USD";

export function formatAmount(value: string | number, currency: string): string {
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (!Number.isFinite(n)) return `${value} ${currency}`;
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency}`;
  }
}

export function currencySymbol(code: string): string {
  return SUPPORTED_CURRENCIES.find(c => c.code === code)?.symbol ?? code;
}

export function compactAmount(value: number, currency: string): string {
  const symbol = currencySymbol(currency);
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M ${symbol}`;
  if (Math.abs(value) >= 1_000) return `${(value / 1_000).toFixed(0)}k ${symbol}`;
  return `${value.toFixed(0)} ${symbol}`;
}
